import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface RadiusSelectorProps {
  value: number;
  onChange: (radius: number) => void;
  className?: string;
}

const RADIUS_OPTIONS = [1, 3, 5, 10];

function RadiusSelector({ value, onChange, className = '' }: RadiusSelectorProps) {
  const { t, i18n } = useTranslation(['search']);
  const direction = i18n.dir();

  return (
    <div className={className} dir={direction}>
      <label className="block text-sm font-medium text-gray-700 dark:text-[var(--pv-color-text)] mb-2">
        {t('search.nearYou.radiusLabel', { defaultValue: 'Search radius' })}
      </label>
      <div className="flex gap-2">
        {RADIUS_OPTIONS.map((radius) => (
          <button
            key={radius}
            type="button"
            onClick={() => onChange(radius)}
            className={[
              'flex-1 py-2 px-3 rounded-lg text-sm font-medium transition-colors',
              value === radius
                ? 'bg-[var(--pv-color-primary)] text-white'
                : 'bg-gray-100 dark:bg-[var(--pv-color-surface-soft)] text-gray-700 dark:text-[var(--pv-color-text)] hover:bg-gray-200 dark:hover:bg-[var(--pv-color-surface-strong)]',
            ].join(' ')}
          >
            {t(`search.nearYou.radius.${radius}km`, { defaultValue: `${radius} km` })}
          </button>
        ))}
      </div>
    </div>
  );
}

export default memo(RadiusSelector);
